import type { ClientEvent, Event } from '@/types';

import {
  useCreateClientEventMutation,
  useCreateEventMutation,
  useDeleteEventMutation,
  useGetAllEventsQuery,
  useGetClientEventsQuery,
  useGetEventsQuery,
  useUpdateClientEventMutation,
  useUpdateEventMutation,
} from '@/store/api/eventApi';

export const useGetAllEvents = () => useGetAllEventsQuery();

export const useGetEvents = () => useGetEventsQuery();

export const useCreateEvent = () => {
  const [trigger, result] = useCreateEventMutation();
  return {
    mutate: (
      variables: Parameters<typeof trigger>[0], 
      options?: { 
        onSuccess?: (data: Event | null) => void; 
        onError?: (error: unknown) => void;
        onSettled?: () => void;
      }
    ) => {
      trigger(variables)
        .unwrap()
        .then((data) => {
          options?.onSuccess?.(data);
          options?.onSettled?.();
        })
        .catch((error) => {
          options?.onError?.(error);
          options?.onSettled?.();
        });
    },
    ...result,
  };
};

export const useUpdateEvent = () => {
  const [trigger, result] = useUpdateEventMutation();
  return {
    mutate: (
      variables: Parameters<typeof trigger>[0], 
      options?: { 
        onSuccess?: (data: Event | null) => void; 
        onError?: (error: unknown) => void;
        onSettled?: () => void;
      }
    ) => {
      trigger(variables)
        .unwrap()
        .then((data) => {
          options?.onSuccess?.(data);
          options?.onSettled?.();
        })
        .catch((error) => {
          options?.onError?.(error);
          options?.onSettled?.();
        });
    },
    ...result,
  };
};

export const useDeleteEvent = () => {
  const [trigger, result] = useDeleteEventMutation();
  return {
    mutate: (
      variables: Parameters<typeof trigger>[0], 
      options?: { 
        onSuccess?: (data: string | null) => void; 
        onError?: (error: unknown) => void;
        onSettled?: () => void;
      }
    ) => {
      trigger(variables)
        .unwrap()
        .then((data) => {
          options?.onSuccess?.(data);
          options?.onSettled?.();
        })
        .catch((error) => {
          options?.onError?.(error);
          options?.onSettled?.();
        });
    },
    ...result,
  };
};

export const useUpdateClientEvent = () => {
  const [trigger, result] = useUpdateClientEventMutation();
  return {
    mutate: (
      variables: Parameters<typeof trigger>[0], 
      options?: { 
        onSuccess?: (data: ClientEvent) => void; 
        onError?: (error: unknown) => void;
        onSettled?: () => void;
      }
    ) => {
      trigger(variables)
        .unwrap()
        .then((data) => {
          options?.onSuccess?.(data);
          options?.onSettled?.();
        })
        .catch((error) => {
          options?.onError?.(error);
          options?.onSettled?.();
        });
    },
    ...result,
  };
};

export const useCreateClientEvent = () => {
  const [trigger, result] = useCreateClientEventMutation();
  return {
    mutate: (
      variables: Parameters<typeof trigger>[0], 
      options?: { 
        onSuccess?: (data: ClientEvent) => void; 
        onError?: (error: unknown) => void;
        onSettled?: () => void;
      }
    ) => {
      trigger(variables)
        .unwrap()
        .then((data) => {
          options?.onSuccess?.(data);
          options?.onSettled?.();
        })
        .catch((error) => {
          options?.onError?.(error);
          options?.onSettled?.();
        });
    },
    ...result,
  };
};

export const useGetClientEvents = () => useGetClientEventsQuery();
